import React from "react";
import { Box, Stack, Paper, Skeleton } from "@mui/material";

interface ConnectionCardSkeletonProps {
    count?: number; // Number of skeleton cards to show
}

const ConnectionCardSkeleton: React.FC<ConnectionCardSkeletonProps> = ({
    count = 3,
}) => {
    return (
        <Stack spacing={2} data-testid="loading-spinner">
            {Array.from({ length: count }).map((_, index) => (
                <Paper
                    key={index}
                    elevation={3}
                    sx={{
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    {/* Left Side: Logo + Info Skeleton */}
                    <Stack direction="row" spacing={2} alignItems="center">
                        {/* Logo Skeleton */}
                        <Skeleton variant="circular" width={48} height={48} />

                        <Box>
                            {/* Store domain skeleton */}
                            <Skeleton variant="text" width={150} height={24} sx={{ mb: 0.5 }} />

                            {/* Created/Updated skeleton */}
                            <Skeleton variant="text" width={200} height={16} sx={{ mb: 0.3 }} />
                            <Skeleton variant="text" width={180} height={16} />
                        </Box>
                    </Stack>

                    {/* Right Side: Delete Button Skeleton */}
                    <Skeleton variant="circular" width={40} height={40} />
                </Paper>
            ))}
        </Stack>
    );
};

export default ConnectionCardSkeleton;
